<template>
  <div>
    <!--list-->
    <div class="tui-product-list" :class="[isList ? 'bg-white' : '']">
      <div class="tui-product-container" v-if="isList">
        <div v-for="(item, index) in productList" :key="index">
          <div
            class="tui-pro-item"
            :class="[isList ? 'tui-flex-list' : '']"
            @click="detail(item)"
          >
            <img
              :src="item.pictureUrl"
              class="tui-pro-img"
              :class="[isList ? 'tui-proimg-list' : '']"
              mode="widthFix"
            />
            <div class="tui-pro-content">
              <div class="tui-pro-tit">{{ item.chineseName }}</div>
              <div class="tui-pro-subtitle">{{ item.subtitle }}</div>

              <div>
                <div class="tui-pro-price">
                  <p class="tui-sale-price">
                    {{ item.recommendRetailPrice }}积分
                  </p>
                  <!-- <p class="tui-factory-price">{{ item.marketPrice }}积分</p> -->
                </div>
                <div class="tui-pro-pay">
                  <!-- <div>
                    <img src="../../../static/images/product/special.png" class="coupon-icon"/>
                    <img src="../../../static/images/product/coupon.png" class="coupon-icon"/>
                  </div> -->
                  <!-- <p v-if="!isPromotion" @click="detail(item)">立即兑换 ></p>
                  <img
                    v-else
                    src="../../../static/images/product/shop.png"
                    class="shop-icon"
                  /> -->
                   <p class="tui-pro-a">已兑出{{item.sales}} <span style="margin-left:10px">库存{{item.available}}</span> </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="tui-product-container" v-if="!isList">
        <div
          class="tui-pro-item"
          v-for="(item, index) in productList"
          :key="index"
          :class="[isList ? 'tui-flex-list' : 'tui-flex-list-2']"
          @click="detail(item)"
        >
          <img
            :src="item.pictureUrl"
            class="tui-pro-img"
            :class="[isList ? 'tui-proimg-list' : '']"
            mode="widthFix"
          />
          <div class="tui-pro-content">
            <div class="tui-pro-tit">{{ item.chineseName }}</div>
            <div class="tui-pro-subtitle">{{ item.subtitle }}</div>
            <div class="tui-flex">
              <div class="tui-pro-price">
                <p class="tui-sale-price">
                  {{ item.recommendRetailPrice }}积分
                </p>
                <!-- <p class="tui-factory-price">积分{{ item.marketPrice }}</p> -->
              </div>
              <div class="tui-pro-pay">
                <!-- <div>
                    <img src="../../../static/images/product/special.png" class="coupon-icon"/>
                    <img src="../../../static/images/product/coupon.png" class="coupon-icon"/>
                  </div> -->
                <!-- <p v-if="!isPromotion" @click.stop="purchase(item)">
                  立即兑换 >
                </p>
                <img
                  v-else
                  src="../../../static/images/product/shop.png"
                  class="shop-icon"
                  @click.stop="shop()"
                /> -->
                 <p class="tui-pro-a">已兑出{{item.sales}} <span style="margin-left:10px">库存{{item.available}}</span> </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    productList: {
      type: Array,
      default: null,
    },
    isList: {
      type: Boolean,
      default: false,
    },
    isPromotion: {
      type: Boolean,
      default: false,
    },
    applyCode:{
      type:String
    },
    cardNo:{
       type:String
    }
  },
  watch: {
    isList: function(indexVal, oldVal) {
      this.isList = indexVal;
    },
  },
  data() {
    return {};
  },
  methods: {
    //商品详情
        detail: function (item) {
           let applyCode = this.applyCode
           let cardNo = this.cardNo
            this.$router.push({
                path: `/productDetails?id=${item.id}&applyCode=${applyCode}&cardNo=${cardNo}`,
            });
        },
    //购买
    purchase(item) {
      console.log("立即购买----");
      this.detail(item);
    },
    //加入购物车
    shop() {},
  },
};
</script>

<style lang="scss" scoped>
.tui-pro-subtitle {
  width: 90%;
  overflow: hidden;
  white-space: nowrap;
  font-size: 20px;
}
/* 商品列表*/
.tui-product-list {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  flex-wrap: wrap;
  box-sizing: border-box;
}

.tui-product-container {
  width: 100%;
  flex: 1;
  // padding-left: 20px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  border-top: #EDEDED 2px solid;

}

// .tui-product-container:last-child {
//   padding-right: 20px;
// }

.tui-pro-item {
  width: 100%;
  // margin-bottom: 20px;
  background: #fff;
  box-sizing: border-box;
  border-radius: 4px;
  overflow: hidden;
  transition: all 0.15s ease-in-out;
}

.tui-flex-list {
  display: flex;
  // border-bottom: #cbcbcb 1px solid;
  padding: 10px 0;
  margin-bottom: 0;
  width: 710px;
  .tui-pro-content {
    width: 100%;
  }
}

.tui-flex-list-2 {
  width: 50%;
  padding:0 2%;
  border-radius: 0;
}
.tui-flex-list-2:nth-child(2n){
  // border-top: 2px solid #EDEDED;
  border-bottom: 2px solid #EDEDED;

}
.tui-flex-list-2:nth-child(2n-1){
  border: 2px solid #EDEDED;
  border-left: none;
  border-top: none;
}
.tui-pro-img {
  width: 100%;
  display: block;
  min-height: 100px;
  // height: 345px;
}

.tui-proimg-list {
  width: 260px;
  height: 260px !important;
  flex-shrink: 0;
}

.tui-pro-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 20px;
}

.tui-pro-tit {
  // width: 90%;
  color: #2e2e2e;
  font-size: 26px;
  word-break: break-all;
  overflow: hidden;
  white-space: nowrap;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  height: 72px;
}

.tui-pro-price {
  padding-top: 18px;
  display: flex;
  align-items: flex-end;
}

.tui-sale-price {
  font-size: 30px;
  font-weight: 500;
  color: #e41f19;
}

.tui-factory-price {
  font-size: 24px;
  color: #a0a0a0;
  text-decoration: line-through;
  padding-left: 12px;
  padding-bottom: 5px;
}

.tui-pro-pay {
  font-size: 22px;
  color: #333333;
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
  .shop-icon {
    width: 36px;
    height: 36px;
  }
  .tui-pro-a{
    color:  #a0a0a0;
  }
}

.coupon-icon {
  width: 62px;
  height: 28px;
  margin-right: 10px;
}

.tui-attr-item {
  max-width: 100%;
  min-width: 120px;
  height: 60px;
  display: -webkit-inline-flex;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #f1f1f1;
  padding: 0 20px;
  box-sizing: border-box;
  margin-right: 20px;
  margin-bottom: 20px;
  font-size: 26px;
  border-radius: 30px;
}

.tui-drawer-content {
  padding: 16px 30px 30px 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
}

.tui-flex-attr {
  flex-wrap: wrap;
  justify-content: flex-start;
}

.tui-flex {
  display: flex;
  justify-content: space-between;
}
/* 商品列表*/
</style>
